module.exports = __webpack_public_path__ + "static/img/Senora.c059ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Senora.jpg
// module id = 09x+
// module chunks = 1